import { createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "w-100 h-100" }
const _hoisted_2 = {
  style: {"margin-left":"1%"},
  id: "msgdiv"
}
const _hoisted_3 = { style: {"height":"50px","margin-top":"2%"} }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Category Name ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Category Order ")
const _hoisted_6 = {
  id: "mydiv",
  style: {"width":"80%","margin-left":"10%","height":"calc(97% - 130px)"}
}
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div style=\"width:calc(100% - 16px);\"><table id=\"tblUserManual\" class=\"w-100\"><thead><tr><th style=\"width:10%;\">No.</th><th style=\"width:60%;\">Category</th><th style=\"width:15%;\">Delete</th><th style=\"width:15%;\">Edit</th></tr></thead></table></div>", 1)
const _hoisted_8 = {
  key: 0,
  style: {"text-align":"center","width":"calc(100% - 16px)"}
}
const _hoisted_9 = {
  key: 1,
  id: "tblbodydiv",
  style: {"height":"calc(100% - 44px)","overflow":"auto"}
}
const _hoisted_10 = {
  id: "tblUserManual",
  class: "w-100"
}
const _hoisted_11 = { id: "tbltbody" }
const _hoisted_12 = { style: {"width":"10%"} }
const _hoisted_13 = { style: {"width":"60%"} }
const _hoisted_14 = { style: {"text-align":"center","width":"15%"} }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { style: {"text-align":"center","width":"15%"} }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  class: "modal fade",
  id: "showModal",
  tabindex: "1",
  "aria-labelledby": "showModalLabel",
  "aria-hidden": "true"
}
const _hoisted_19 = { class: "modal-dialog modal-dialog-scrollable modal-lg" }
const _hoisted_20 = {
  class: "modal-content",
  style: {"width":"350px"}
}
const _hoisted_21 = { class: "modal-header" }
const _hoisted_22 = {
  class: "modal-title",
  id: "showModalLabel"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1 /* HOISTED */)
const _hoisted_24 = {
  class: "modal-body",
  id: "modal-body",
  style: {"text-align":"left","font-size":"13px"}
}
const _hoisted_25 = { style: {"height":"30%"} }
const _hoisted_26 = { class: "row-div margin-bottom-20" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { class: "adjusting-position fs-6" }, "Category Name", -1 /* HOISTED */)
const _hoisted_28 = { class: "col-sm-7 errmsg" }
const _hoisted_29 = { class: "row-div margin-bottom-20" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { class: "adjusting-position fs-6" }, "Category Order", -1 /* HOISTED */)
const _hoisted_31 = { class: "col-sm-7 errmsg" }
const _hoisted_32 = { class: "modal-footer" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  id: "modalCancel",
  class: "btn btn-secondary",
  style: {"width":"83px","height":"35px","text-align":"center"},
  "data-bs-dismiss": "modal"
}, " Close ", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["Loading"], { isLoading: $setup.isLoading }, null, 8 /* PROPS */, ["isLoading"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode($setup["Alert"], {
        alertMessage: $setup.alertMessage,
        alertState: $setup.alertState
      }, null, 8 /* PROPS */, ["alertMessage", "alertState"])
    ]),
    _createVNode($setup["AdminNavigation"], { menuTile: $setup.title }, null, 8 /* PROPS */, ["menuTile"]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _withDirectives(_createElementVNode("input", {
        type: "textbox",
        style: {"width":"150px","margin-left":"2%","margin-right":"2%"},
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.cateName) = $event))
      }, null, 512 /* NEED_PATCH */), [
        [_vModelText, $setup.cateName]
      ]),
      _hoisted_5,
      _withDirectives(_createElementVNode("input", {
        type: "textbox",
        style: {"width":"150px","margin-left":"2%"},
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.cateOrder) = $event))
      }, null, 512 /* NEED_PATCH */), [
        [_vModelText, $setup.cateOrder]
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-secondary",
        style: {"width":"62px","height":"35px","text-align":"center","margin-left":"2%"},
        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.addCategoryList())),
        "data-bs-dismiss": "modal"
      }, " Add "),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-secondary",
        style: {"width":"62px","height":"35px","text-align":"center","margin-left":"2%"},
        onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.backbtnEvt())),
        "data-bs-dismiss": "modal"
      }, " Back ")
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      ($setup.categoryInfo.length == 0 && $setup.getData)
        ? (_openBlock(), _createElementBlock("h4", _hoisted_8, " No data "))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("table", _hoisted_10, [
              _createElementVNode("tbody", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.categoryInfo, (info, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", _hoisted_12, _toDisplayString(index + 1), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_13, _toDisplayString(info.category), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_14, [
                      _createElementVNode("button", {
                        class: "btn btn-primary button-design-scanCategory",
                        style: {"width":"70px"},
                        onClick: ($event: any) => ($setup.deleteCategoryList(info.category))
                      }, " Delete ", 8 /* PROPS */, _hoisted_15)
                    ]),
                    _createElementVNode("td", _hoisted_16, [
                      _createElementVNode("a", {
                        "data-bs-toggle": "modal",
                        "data-bs-target": "#showModal",
                        onClick: ($event: any) => ($setup.modalShow1(info.category)),
                        class: "btn btn-primary button-design-scanCategory w-30",
                        style: {"width":"70px"}
                      }, " Edit ", 8 /* PROPS */, _hoisted_17)
                    ])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ])
          ]))
    ]),
    _createCommentVNode(" Modal "),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("h5", _hoisted_22, _toDisplayString($setup.modalSubject[0]), 1 /* TEXT */),
            _hoisted_23
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "textbox",
                    class: "adjusting-position form-control input-item",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.categoryName) = $event)),
                    maxlength: "255"
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelText, $setup.categoryName]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("span", _hoisted_28, _toDisplayString($setup.errCategoryName), 1 /* TEXT */)
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _hoisted_30,
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "textbox",
                    class: "adjusting-position form-control input-item",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.categoryOrder) = $event)),
                    maxlength: "255"
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelText, $setup.categoryOrder]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("span", _hoisted_31, _toDisplayString($setup.errCategoryOrder), 1 /* TEXT */)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", null, [
              _hoisted_33,
              _createElementVNode("button", {
                type: "button",
                id: "btnUpdate",
                class: "btn btn-primary button-design",
                style: {"width":"83px","height":"35px","text-align":"center"},
                onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.updateCategoryList()))
              }, " Update ")
            ])
          ])
        ])
      ])
    ])
  ]))
}